module.exports = __webpack_public_path__ + "img/edasneo-icon-white.b82e5b04.png";